<div class="{{isLoading}}"></div>
<div class="snackbar {{show}}">{{message}}</div>
<section class="signup-hero">

    <div class="signup-form">
        <h1>Sign Up</h1>

        
        <form #signupform="ngForm">

            <table class="signup-table">
                <tr>
                    <td>
                        <label>First Name</label>
                    </td>
                    <td>
                        <input class="signup-text" name="first_name" type="text" placeholder="First Name" [(ngModel)]="params.first_name" required>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Last Name</label>
                    </td>
                    <td>
                        <input class="signup-text" name="last_name" type="text" placeholder="Last Name" [(ngModel)]="params.last_name" required>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Email</label>
                    </td>
                    <td>
                        <input class="signup-text" name="email" type="text" placeholder="Email Address" [(ngModel)]= "params.email" required>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>Password</label>
                    </td>
                    <td>
                        <input class="signup-text" name="password" type="password" placeholder="Enter Password" [(ngModel)]="params.password" required>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>Confirm Password</label>
                    </td>
                    <td>
                        <input class="signup-text" name="cpassword" type="password" placeholder="Re-enter Password" [(ngModel)]="cPassword" required>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>Phone No.</label>
                    </td>
                    <td>
                        <input class="signup-text" name="phone" type="text" placeholder="eg +92305000002" [(ngModel)]="params.mobile" required>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>CNIC</label>
                    </td>
                    <td>
                        <input class="signup-text" type="text" name="cnic" placeholder="eg. 42401-1277382-2" [(ngModel)]="params.cnic" required>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>Gender</label>
                    </td>
                    <td>
                        <select class="signup-select" name="gender" [(ngModel)]="params.gender" required>
                            <option value=1>Male</option>
                            <option value=2>Female</option>
                        </select>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>Country</label>
                    </td>
                    <td>
                        <select class="signup-select" name="country" [(ngModel)]="params.country">
                            <option value="1">Pakistan</option>
                        </select>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>City</label>
                    </td>
                    <td>
                        <select class="signup-select" name="city" [(ngModel)]="params.city">
                            <option value="1">Karachi</option>
                        </select>
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>*Street Address</label>
                    </td>
                    <td>
                        <textarea class="signup-text-area" name="message" rows="10" cols="30" placeholder="Enter Complete Street Address " [(ngModel)]="params.address" required></textarea>
                    </td>
                </tr>

            </table>


            <br><br>

            <div class="block">
            <input type="checkbox" [(ngModel)]="agree" name="checkbox" required><label class="term">The information above is true and I agree to the <a href="#">terms and conditions.</a></label>
            </div>

            <br>
            <div class="block">
            <button class="sign" type="submit" (click)="signup()">Sign Up</button>
            </div>
        </form>

        <br>
        <br>


    </div>

</section>